import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

import Landing from "@/pages/Landing";
import Login from "@/pages/auth/Login";
import RegisterManager from "@/pages/auth/RegisterManager";
import RegisterResident from "@/pages/auth/RegisterResident";
import PendingScreen from "@/pages/auth/PendingScreen";

import ResidentLayout from "@/layouts/ResidentLayout";
import Home from "@/pages/resident/Home";
import Community from "@/pages/resident/Community";
import Services from "@/pages/resident/Services";
import Radar from "@/pages/resident/Radar";
import Profile from "@/pages/resident/Profile";
import Notifications from "@/pages/resident/Notifications";

import ManagerLayout from "@/layouts/ManagerLayout";
import Overview from "@/pages/manager/Overview";
import Communication from "@/pages/manager/Communication";
import Residents from "@/pages/manager/Residents";
import CommunityMgmt from "@/pages/manager/CommunityMgmt";
import ServicesMgmt from "@/pages/manager/ServicesMgmt";
import ManagerProfile from "@/pages/manager/ManagerProfile";

const FullLoader = () => (
  <div className="min-h-[100dvh] flex items-center justify-center bg-background">
    <Loader2 className="w-8 h-8 text-primary animate-spin" />
  </div>
);

function Protected({ role, children }) {
  const { user } = useAuth();
  if (user === undefined) return <FullLoader />;
  if (!user) return <Navigate to="/entrar" replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "manager" ? "/gestao" : "/app"} replace />;
  }
  if (user.role === "resident" && user.status === "blocked") return <PendingScreen />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/entrar" element={<Login />} />
          <Route path="/cadastro/sindico" element={<RegisterManager />} />
          <Route path="/cadastro/morador" element={<RegisterResident />} />

          <Route path="/app" element={<Protected role="resident"><ResidentLayout /></Protected>}>
            <Route index element={<Home />} />
            <Route path="comunidade" element={<Community />} />
            <Route path="servicos" element={<Services />} />
            <Route path="radar" element={<Radar />} />
            <Route path="perfil" element={<Profile />} />
            <Route path="notificacoes" element={<Notifications />} />
          </Route>

          <Route path="/gestao" element={<Protected role="manager"><ManagerLayout /></Protected>}>
            <Route index element={<Overview />} />
            <Route path="comunicacao" element={<Communication />} />
            <Route path="moradores" element={<Residents />} />
            <Route path="comunidade" element={<CommunityMgmt />} />
            <Route path="servicos" element={<ServicesMgmt />} />
            <Route path="perfil" element={<ManagerProfile />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
